import React, {Component, Fragment} from "react";

import Layout from "../layout";
import './payment-result-page.css'
import {Card, Container, Image} from "react-bootstrap";
import successImg from './images/success.png'
import errorImg from './images/error.png'
import {withTranslation} from "react-i18next";
import {compose} from "../../utils";
import withRouter from "../hoc/with-router";
import queryString from 'query-string'


class PaymentResultPage extends Component {
    getMessage = () => {
        const {success} = this.props

        if (success) {
            return this.getSuccessMessage()
        } else {
            return this.getErrorMessage()
        }
    }
    getSuccessMessage = () => {
        const {t} = this.props

        return (
            <Fragment>
                <div className="apay-payment-success-msg">{t("paymentResult.successMessage")}</div>
                <div className="text-center mt-3"><Image src={successImg} rounded width="80px"/></div>
                <div className="text-center mt-3">
                    {this.getBackUrl()}
                </div>
            </Fragment>
        )
    }
    getErrorMessage = () => {
        const {t} = this.props
        return (
            <Fragment>
                <div className="apay-payment-error-msg">{t("paymentResult.errorMessage")}</div>
                <div className="text-center mt-3"><Image src={errorImg} rounded width="80px"/></div>
                <div className="text-center mt-3">
                    {this.getBackUrl()}
                </div>
            </Fragment>
        )
    }

    getBackUrl = () => {
        const {t, location} = this.props
        const queryParams = queryString.parse(location.search)
        let backUrl = "https://airbapay.kz/"
        let backUrlLabel = t("backToMain")
        if (queryParams.backUrl!==undefined && queryParams.backUrl!==""){
            backUrl = queryParams.backUrl
            backUrlLabel = t("backToShop")
        }
        return (
            <a href={backUrl} className="apay-payment-result-backurl"> {backUrlLabel}</a>
        )
    }
    render() {

        const {t} = this.props
        return (
            <Layout>
                <Container className="d-flex flex-row justify-content-center h-100">

                    <div className="apay-payment-result-form mt-5">
                        <div className="apay-payment-result-form-title">
                            {t("paymentResult.title")}
                        </div>

                        <Card className="rounded-5 p-2">
                            <Card.Body>

                                {this.getMessage()}


                            </Card.Body>
                        </Card>
                    </div>
                </Container>
            </Layout>
        )
    }
}

export default compose(
    withTranslation(),
    withRouter())(PaymentResultPage);